import { render, staticRenderFns } from "./AppointmentReasonForm.vue?vue&type=template&id=27317b8c&"
import script from "./AppointmentReasonForm.vue?vue&type=script&lang=js&"
export * from "./AppointmentReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports